import React, { useState, forwardRef, useImperativeHandle } from "react";
import BackDrop from "../shared/back-drop"
import { XIcon } from "@heroicons/react/solid"
import * as styles from "./lightbox.module.css"

import { CSSTransition } from "react-transition-group"

const Lightbox = ({ title, children,className }, ref) => {
    useImperativeHandle(ref, () => ({
        show: (title, message) => {
            setState((state) => ({ ...state, showModal: true, title: title, message: message }))
        },
        hide: () => {
            setState((state) => ({ ...state, showContent: false }))
        }
    }));
    const [state, setState] = useState({ showContent: false });

    return <BackDrop show={state.showModal} onEntered={() => {
        setState((state) => ({ ...state, showContent: true }));
    }}>
        <CSSTransition in={state.showContent} classNames="zoomIn" onExited={() => { setState((state) => ({ ...state, showModal: false })) }} timeout={600} unmountOnExit>
            <div className={styles.lightbox_container+" "+(className?className:"")}>
                <button onClick={() => {
                    setState((state) => ({ ...state, showContent: false }))
                }} className={styles.lightbox_btn_close}><XIcon className="w-6 h-6 text-gray-500" /></button>
                {title && <h3 className={styles.lightbox_title}>{title}</h3>}
                <div className={styles.lightbox_content}>
                    {children}
                </div>
            </div>
        </CSSTransition>
    </BackDrop>
}

export default forwardRef(Lightbox);